// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"dashboard_dashboardContainer__NL931","MuiGrid-item":"dashboard_MuiGrid-item__hnK-m","MuiPaper-root":"dashboard_MuiPaper-root__JLHEQ"};